"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = __importStar(require("../index"));
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("@/react/pages/qc/base/{utils}/constants");
const multi_layer_dropdown_1 = __importDefault(require("@/libraries/multi-layer-dropdown"));
function WatchedArray(initial = [], onChange) {
    return new Proxy(initial, {
        get(target, prop, receiver) {
            const orig = Reflect.get(target, prop, receiver);
            if (typeof orig === 'function') {
                return (...args) => {
                    const result = orig.apply(target, args);
                    const action = String(prop);
                    if (['push', 'pop', 'shift', 'unshift', 'splice'].includes(action)) {
                        onChange(action, args, result);
                    }
                    return result;
                };
            }
            return orig;
        },
        set(target, prop, value, receiver) {
            if (prop === 'length' && value === 0) {
                const result = Reflect.set(target, prop, value, receiver);
                onChange('length_reset', [], result);
                return result;
            }
            return Reflect.set(target, prop, value, receiver);
        }
    });
}
function escapeHTML(str) {
    return str
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
}
class QCDataTable extends index_1.default {
    selected_rows = new Map();
    modified_cells = new Map();
    undo_timeline = WatchedArray([], (action, args, result) => {
        this._update_undo_button();
    });
    redo_timeline = WatchedArray([], (action, args, result) => {
        this._update_redo_button();
    });
    undo_button = null;
    redo_button = null;
    periods = {};
    cell_save_callback = () => { };
    cell_cancel_callback = () => { };
    row_add_callback = () => { };
    retentionValues = [];
    rowPositionKey;
    clientSide;
    catSubRec;
    minMax;
    undo(fireChange = true) {
        this._handle_timeline_action(this.undo_timeline, this.redo_timeline, 'oldValue', fireChange);
    }
    redo() {
        this._handle_timeline_action(this.redo_timeline, this.undo_timeline, 'currentValue');
    }
    setRowVisuallySelected(row, isSelected) {
        row.classList.toggle('selected', isSelected);
        const input = row.querySelector('input.row-select');
        if (input) {
            input.checked = isSelected;
        }
    }
    selectRow(rowId, isSelected) {
        const row = this.dt.row(`[data-id="${rowId}"]`).node() || this.getTable().querySelector(`tbody tr[data-id="${rowId}"]`);
        this.setRowVisuallySelected(row, isSelected);
        const cells = Array.from(row.querySelectorAll('td'));
        cells.forEach(cell => {
            if (cell.querySelector('button.cancel')) {
                cell.querySelector('button.cancel')?.click();
            }
        });
        if (isSelected) {
            const rowData = {};
            cells.forEach(cell => rowData[cell.dataset.header || ''] = cell.innerHTML.trim());
            rowData['_meta'] = {};
            if (row.dataset.id) {
                rowData['_meta'].id = Number(row.dataset.id);
            }
            if (row.dataset.excel_order) {
                rowData['_meta'].excel_order = row.dataset.excel_order;
            }
            this.selected_rows.set(Number(row.dataset.id), rowData);
        }
        else {
            this.selected_rows.delete(Number(row.dataset.id));
        }
        this._check_select_all_rows_checkbox();
    }
    _check_select_all_rows_checkbox() {
        const selectedRowsCount = this.selected_rows.size;
        if (selectedRowsCount !== 0) {
            this.dt_wrapper.querySelector('.selected-rows-count').textContent = `Selected ${selectedRowsCount} row(s)`;
        }
        else {
            this.dt_wrapper.querySelector('.selected-rows-count').textContent = '';
        }
        const selectAllCheckbox = this.dt_wrapper.querySelector('.all');
        if (selectAllCheckbox) {
            const allRows = this.getTable().querySelectorAll('tbody tr');
            const allSelected = Array.from(allRows).every(row => {
                return this.selected_rows.has(Number(row.dataset.id));
            });
            selectAllCheckbox.checked = allSelected;
        }
    }
    selectAllHandler(isSelected) {
        const rows = this.getTable().querySelectorAll('tbody tr');
        rows.forEach(row => {
            const rowId = row.dataset.id;
            if (rowId) {
                this.selectRow(rowId, isSelected);
            }
        });
    }
    clearSelectedRows() {
        this.selected_rows.clear();
        const rows = this.getTable().querySelectorAll('tbody tr');
        rows.forEach(row => {
            this.setRowVisuallySelected(row, false);
        });
        this.dt_wrapper.querySelector('.selected-rows-count').textContent = '';
    }
    getSelectedRows() {
        const selectedRows = [];
        this.selected_rows.forEach((rowData, rowId) => {
            rowData._meta = rowData._meta || {};
            selectedRows.push(rowData);
        });
        return selectedRows;
    }
    getSelectedRowsDOM() {
        const selectedRows = this.getSelectedRows();
        const rows = selectedRows.map(row => {
            return this.dt_wrapper.querySelector(`tr[data-id="${row._meta.id}"]`) || '';
        });
        return rows.filter(row => row !== '');
    }
    getRow(rowId) {
        return this.selected_rows.get(Number(rowId)) ||
            (() => {
                const cells = this.getTable().querySelectorAll(`tbody tr[data-id="${rowId}"] td`);
                const obj = {};
                cells.forEach((cell) => {
                    const key = cell.dataset.header || '';
                    if (key)
                        obj[key] = cell.innerHTML.trim();
                });
                const row = this.getTable().querySelector(`tbody tr[data-id="${rowId}"]`);
                if (row) {
                    obj._meta = obj._meta || {};
                    if (row.dataset.id)
                        obj._meta.id = row.dataset.id;
                    if (row.dataset.excel_order)
                        obj._meta.excel_order = row.dataset.excel_order;
                }
                return obj;
            })();
    }
    getParsedRow(rowId) {
        const rowData = this.getRow(rowId);
        if (!rowData) {
            throw new Error(`Row with id ${rowId} not found`);
        }
        return this.parseRow(rowData);
    }
    _update_undo_button() {
        if (this.undo_button) {
            if (this.undo_timeline.length > 0) {
                this.undo_button.classList.remove('disabled');
            }
            else {
                this.undo_button.classList.add('disabled');
            }
        }
    }
    _update_redo_button() {
        if (this.redo_button) {
            if (this.redo_timeline.length > 0) {
                this.redo_button.classList.remove('disabled');
            }
            else {
                this.redo_button.classList.add('disabled');
            }
        }
    }
    _get_cell_key(id, header) {
        return `${id}:${header}`;
    }
    _get_row_id_from_cell_key(cellKey) {
        return cellKey.split(':')[0];
    }
    _get_cell_header_from_cell_key(cellKey) {
        const header = cellKey.split(':')[1];
        if (!isNaN(Number(header))) {
            const cellIndex = Number(header);
            const cellHeaderElement = this.dt.column(cellIndex).header();
            return {
                col: cellIndex,
                cellHeader: cellHeaderElement.dataset.header || ''
            };
        }
        else {
            return {
                col: header,
                cellHeader: header
            };
        }
    }
    _parse_dom_node(html) {
        const el = new DOMParser().parseFromString(html, 'text/html').body.firstElementChild;
        if (!el) {
            throw new Error('Failed to parse DOM node from HTML string.');
        }
        return el;
    }
    _sanitize_input(inputValue) {
        if (!inputValue)
            return '';
        return inputValue
            .replace(/&nbsp;/gi, ' ')
            .replace(/&#160;/gi, ' ')
            .replace(/&amp;/gi, '&')
            .replace(/&lt;/gi, '')
            .replace(/&gt;/gi, '')
            .replace(/&quot;/gi, '"')
            .replace(/&#39;/gi, "'")
            .replace(/<[^>]*>/g, ' ')
            .replace(/[\u00A0\u2028\u2029\u00B6\n\r]/g, ' ')
            .replace(/\s{2,}/g, ' ')
            .trim();
    }
    parseTaxonomy(taxonomyHtml) {
        const node = this._parse_dom_node(taxonomyHtml);
        const category_id = node?.querySelector('[data-category-id]')?.dataset.categoryId === 'null' ? null : node?.querySelector('[data-category-id]')?.dataset.categoryId;
        const subcategory_id = node?.querySelector('[data-subcategory-id]')?.dataset.subcategoryId === 'null' ? null : node?.querySelector('[data-subcategory-id]')?.dataset.subcategoryId;
        const record_type = node?.querySelector('[data-record-type-id]')?.dataset.recordTypeId === 'null' ? null : node?.querySelector('[data-record-type-id]')?.dataset.recordTypeId;
        const result = {};
        result.record_type = record_type;
        result.subcategory_id = subcategory_id;
        result.category_id = category_id;
        return result;
    }
    parseTaxonomyString(taxonomyHtml, taxonomyString) {
        const map = {
            cat: 'category_id',
            sub: 'subcategory_id',
            rec: 'record_type'
        };
        const node = this._parse_dom_node(taxonomyHtml);
        return {
            [map[taxonomyString]]: (() => {
                const category_id = node?.dataset.categoryId;
                const subcategory_id = node?.dataset.subcategoryId;
                const record_type = node?.dataset.recordTypeId;
                if (taxonomyString === 'cat') {
                    return category_id === 'null' ? null : category_id;
                }
                if (taxonomyString === 'sub') {
                    return subcategory_id === 'null' ? null : subcategory_id;
                }
                if (taxonomyString === 'rec') {
                    return record_type === 'null' ? null : record_type;
                }
                return null;
            })()
        };
    }
    parseLink(linkHtml) {
        const node = this._parse_dom_node(linkHtml);
        return {
            legal_link: node?.textContent
        };
    }
    parsePeriod(periodHtml) {
        const node = this._parse_dom_node(periodHtml);
        return {
            period: node.dataset.periodId === 'null' ? null : node.dataset.periodId,
        };
    }
    parseJurisdiction(jurisdictionHtml) {
        const node = this._parse_dom_node(jurisdictionHtml);
        const countryId = node?.querySelector('[data-country-id]')?.dataset.countryId || null;
        const cityId = node?.querySelector('[data-city-id]')?.dataset.cityId || null;
        const result = {};
        if (countryId) {
            result.country_id = countryId;
        }
        if (cityId) {
            result.city_id = cityId;
        }
        return result;
    }
    parseCatSubRec(rowId) {
        const row = this.getRow(rowId);
        return {
            ...this.parseTaxonomyString(row.category_id, 'cat'),
            ...this.parseTaxonomyString(row.subcategory_id, 'sub'),
            ...this.parseTaxonomyString(row.record_type, 'rec'),
        };
    }
    parseRow(row) {
        return {
            ...row,
            ...this.parseCatSubRec(row._meta.id),
            ...this.parseLink(row.legal_link),
            ...this.parsePeriod(row.period),
            ...this.parseJurisdiction(row.jurisdiction),
        };
    }
    _row_callback(row) {
        const { id } = row.dataset;
        const position = row.dataset[this.rowPositionKey];
        row.select = (isSelected) => {
            this.selectRow(id, isSelected);
        };
        const checkbox = row.querySelector('input.row-select');
        if (checkbox) {
            checkbox.addEventListener('change', (e) => {
                this.selectRow(id, e.target.checked);
            });
        }
        if (this.selected_rows.has(Number(id))) {
            this.setRowVisuallySelected(row, true);
        }
        row.querySelectorAll('td').forEach((cell, index) => index > 0 && this._cell_callback(cell, row, index));
    }
    addRowDuplicate(position) {
        const referenceRow = this.getTable().querySelector(`tbody tr[data-${this.rowPositionKey}="${position}"]`);
        if (!referenceRow) {
            throw new Error(`No row found with data-${this.rowPositionKey}="${position}"`);
        }
        referenceRow.querySelectorAll('td').forEach((cell, index) => {
            const cancelBtn = cell.querySelector('.btn.cancel');
            if (cancelBtn) {
                cancelBtn.click();
            }
        });
        const clonedRowData = Array.from(referenceRow.querySelectorAll('td')).map((cell, index) => {
            return cell.innerHTML.trim();
        });
        return this.addNewRow(clonedRowData, position);
    }
    addRow(rowData, position) {
        const rowApi = this.dt.row.add(rowData);
        const x = rowApi.node();
        const referenceRow = this.getTable().querySelector(`tbody tr[data-${this.rowPositionKey}="${position}"]`);
        if (x && referenceRow) {
            referenceRow.insertAdjacentElement('afterend', x);
        }
        return {
            row: x,
            rowData,
            referenceRow
        };
    }
    addNewRow(rowData, position) {
        const { row, referenceRow } = this.addRow(rowData, position);
        row.dataset.id = Math.random() + '';
        row.dataset.isNewRow = 'true';
        row.dataset[this.rowPositionKey] = position.toString();
        this._row_callback(row);
        return {
            row,
            referenceRow,
            rowData
        };
    }
    reset() {
        this.clearSelectedRows();
        this.modified_cells.clear();
        this.undo_timeline.length = 0;
        this.redo_timeline.length = 0;
        this._update_undo_button();
        this._update_redo_button();
    }
    _cell_callback(cell, row, colIndex) {
        const rowId = row.dataset.id;
        const cellKey = this._get_cell_key(rowId, cell.dataset.header || colIndex.toString());
        const cellHeaderElement = this.dt.column(colIndex).header() || this.getTable().querySelector(`th[data-header="${cell.dataset.header}"]`);
        if (cellHeaderElement.dataset.editable) {
            cell.dataset.editable = cellHeaderElement.dataset.editable.trim();
        }
        const cellHeader = cell.dataset.header || cellHeaderElement.textContent || '';
        if (cellHeader === 'period') {
            const r = row.querySelector(`td[data-header="retention"]`);
            if (r)
                if (this.retentionValues.includes(r.innerHTML.trim())) {
                    cell.removeAttribute('data-editable');
                }
                else {
                    cell.dataset.editable = 'period-dropdown';
                }
        }
        cell.modify = this._modify_cell.bind(this, cellKey);
        cell.dataset.cellKey = cellKey;
        cell.apiCall = async (promise) => {
            cell.classList.add('disabled', 'loading');
            cell.setAttribute('disabled', 'true');
            try {
                const result = await promise;
                return result;
            }
            finally {
                cell.classList.remove('disabled');
                cell.removeAttribute('disabled');
            }
        };
        if (this.modified_cells.has(cellKey)) {
            cell.modify(this.modified_cells.get(cellKey), false, this.clientSide);
        }
        this.dt.on('select', (e, dt, type, indexes) => {
            if (type === 'cell') {
                this.getTable().querySelectorAll('td[data-type="new"]').forEach(c => c.classList.remove('selected'));
            }
        });
        cell.addEventListener('click', async (e) => {
            const isEditable = cell.dataset.editable && cell.dataset.editable !== 'false' && cell.dataset.editable !== 'null';
            if (!isEditable)
                return;
            const buttonContainer = `<div class="flex items-center gap-2 justify-end">
								<button class="btn save btn-icon btn-round bg-transparent h-[24px] min-h-0 min-w-0 p-0 font-MaterialIcons text-xl font-normal border-normal px-2 border-primary text-primary hover:bg-primary hover:text-white">check</button>
								<button class="btn cancel btn-icon btn-round bg-transparent h-[24px] min-h-0 min-w-0 p-0 font-MaterialIcons text-xl font-normal border-normal px-2 border-danger text-danger hover:bg-danger hover:text-white">close</button>
							</div>`;
            const toggleEditing = (isEditing) => {
                cell.dataset.editing = isEditing;
                if (isEditing) {
                    this.selected_rows.has(Number(rowId)) && this.selectRow(rowId, false);
                    const keydownHandler = (e) => {
                        if (e.key === 'Escape') {
                            e.stopPropagation();
                            cell.querySelector('button.cancel')?.click();
                            document.removeEventListener('keydown', keydownHandler, true);
                        }
                        else if (e.key === 'Enter') {
                            e.stopPropagation();
                            cell.querySelector('button.save')?.click();
                            document.removeEventListener('keydown', keydownHandler, true);
                        }
                    };
                    document.addEventListener('keydown', keydownHandler, true);
                }
                this.getTable().querySelectorAll('td[data-editing="true"]').forEach(c => c.querySelector('button.cancel')?.click());
            };
            const onCellSaveAndCancel = (isSave, oldValue, currentValue) => {
                if (isSave && currentValue !== oldValue) {
                    cell.modify(currentValue, true);
                    this.undo_timeline.push({
                        action: 'edit',
                        cellKey,
                        currentValue,
                        oldValue,
                    });
                    this.redo_timeline.length = 0;
                }
                else {
                    cell.innerHTML = oldValue;
                }
                toggleEditing(false);
            };
            if (isEditable) {
                this.dt.rows().cells().deselect();
                if (cell.dataset.editing === 'true')
                    return;
                toggleEditing(true);
                const oldValue = cell.innerHTML.trim();
                if (cellHeaderElement.dataset.editable?.split('/')[0] === 'plaintext') {
                    const validation = cellHeaderElement.dataset.editable?.split('/')[1];
                    const template = `<div class="flex gap-2 flex-col">
										<div contenteditable="true" class="editable-cell h-full w-full py-[9px] px-[6px] bg-white border-thin border-grey rounded-primary focus:outline-none">
											${oldValue}
										</div>	
										${buttonContainer}
									</div>`;
                    cell.innerHTML = template;
                    cell.querySelector('.editable-cell').focus();
                    const save = (e) => {
                        let inputValue = cell.querySelector('.editable-cell').textContent.trim();
                        inputValue = this._sanitize_input(inputValue);
                        onCellSaveAndCancel(true, oldValue, inputValue);
                        e.stopPropagation();
                    };
                    const cancel = (e) => {
                        onCellSaveAndCancel(false, oldValue);
                        e.stopPropagation();
                    };
                    cell.querySelector('button.save').onclick = save;
                    cell.querySelector('button.cancel').onclick = cancel;
                    cell.querySelector('.editable-cell')?.addEventListener('paste', function (e) {
                        e.preventDefault();
                        const text = e.clipboardData?.getData('text/plain') || '';
                        const selection = window.getSelection();
                        if (!selection || !selection.rangeCount)
                            return;
                        selection.deleteFromDocument();
                        selection.getRangeAt(0).insertNode(document.createTextNode(text));
                    });
                }
                if (cellHeaderElement.dataset.editable === 'taxonomy-dropdown') {
                    const parent = cell.querySelector('.section');
                    const category = cell.querySelector('[data-category-id]');
                    const subcategory = cell.querySelector('[data-subcategory-id]');
                    const recordType = cell.querySelector('[data-record-type-id]');
                    const template = `<p class="title">Select Taxonomy</p>
										<div class="content dropdown mt-1"></div>`;
                    const dropdownDiv = document.createElement('div');
                    dropdownDiv.innerHTML = template;
                    dropdownDiv.classList.add('group');
                    parent.appendChild(dropdownDiv);
                    const dd = new multi_layer_dropdown_1.default(parent.querySelector('.dropdown'), {
                        searchPlaceholder: 'Select Taxonomy',
                        levels: ['Categories', 'Subcategories',
                            'Record Types'
                        ],
                        keys: ['category', 'subcategory', 'record_type'],
                        multiSelect: false
                    });
                    dd.initializeData(this.catSubRec);
                    dropdownDiv.addEventListener('itemSelect', (e) => {
                        const customEvent = e;
                        const { name, value, key, parent } = customEvent.detail;
                        const reset = (el, datasetKey) => {
                            el.innerHTML = '';
                            el.dataset[datasetKey] = 'null';
                        };
                        const set = (el, datasetKey, name, value) => {
                            el.dataset[datasetKey] = value;
                            el.innerHTML = name;
                        };
                        if (key === 'category') {
                            reset(subcategory, 'subcategoryId');
                            reset(recordType, 'recordTypeId');
                            set(category, 'categoryId', name, value);
                        }
                        else if (key === 'subcategory') {
                            reset(recordType, 'recordTypeId');
                            set(subcategory, 'subcategoryId', name, value);
                            set(category, 'categoryId', parent.name, parent.value);
                        }
                        else if (key === 'record_type') {
                            set(recordType, 'recordTypeId', name, value);
                            set(subcategory, 'subcategoryId', parent.name, parent.value);
                            set(category, 'categoryId', parent.parent.name, parent.parent.value);
                        }
                    });
                    {
                        const editableCell = document.createElement('div');
                        editableCell.innerHTML = `<div class="flex gap-2 flex-col">
												<div class="editable-cell h-full w-full py-[9px] px-[6px] bg-white border-thin border-grey rounded-primary focus:outline-none">
												</div>
												${buttonContainer}
											</div>
										`;
                        const editableDiv = editableCell.querySelector('.editable-cell');
                        if (editableDiv) {
                            editableDiv.appendChild(parent);
                        }
                        cell.appendChild(editableCell);
                        const save = (e) => {
                            dropdownDiv.remove();
                            const currentValue = parent.outerHTML;
                            onCellSaveAndCancel(true, oldValue, currentValue);
                            e.stopPropagation();
                        };
                        const cancel = (e) => {
                            onCellSaveAndCancel(false, oldValue);
                            e.stopPropagation();
                        };
                        const saveButton = editableCell.querySelector('button.save');
                        const cancelButton = editableCell.querySelector('button.cancel');
                        if (saveButton)
                            saveButton.onclick = save;
                        if (cancelButton)
                            cancelButton.onclick = cancel;
                    }
                }
                const getCellValue = (cell, attr) => cell.querySelector(`[data-${attr}]`)?.getAttribute(`data-${attr}`) || '';
                const getOptions = (arr, selectedValue) => arr.map(({ value, name }) => `<option value="${value}" ${value.toString() === selectedValue.toString() ? 'selected' : ''}>${name}</option>`).join('');
                const getSaveHandler = (cell, attr, list, oldValue, onCellSaveAndCancel) => (e) => {
                    const inputValue = cell.querySelector('select').value;
                    const label = list.find(c => c.value.toString() === inputValue.toString())?.name || '';
                    const template = `<div data-${attr}="${inputValue}">${label}</div>`;
                    onCellSaveAndCancel(true, oldValue, template);
                    e.stopPropagation();
                };
                const getCancelHandler = (oldValue, onCellSaveAndCancel) => (e) => {
                    onCellSaveAndCancel(false, oldValue);
                    e.stopPropagation();
                };
                const renderDropdownEditor = ({ cell, attr, options, selectedValue, buttonContainer, onSave, onCancel, }) => {
                    const template = `
						<div no-empty class="flex gap-2 flex-col" ${attr ? `data-${attr}="${selectedValue}"` : 'null'}>
							<div class="editable-cell h-full w-full py-[4px] bg-white focus:outline-none">
								<select data-search="true">${getOptions(options, selectedValue)}</select>
							</div>
							${buttonContainer}
						</div>
					`;
                    cell.innerHTML = template;
                    setTimeout(() => {
                        cell.querySelector('.display').click();
                        cell.querySelector('.display').focus();
                    }, 10);
                    cell.querySelector('button.save').onclick = onSave;
                    cell.querySelector('button.cancel').onclick = onCancel;
                };
                if (cellHeaderElement.dataset.editable === 'cat-dropdown' ||
                    cellHeaderElement.dataset.editable === 'subcat-dropdown' ||
                    cellHeaderElement.dataset.editable === 'rt-dropdown') {
                    const catCell = this.dt_wrapper?.querySelector(`tr[data-id="${rowId}"] td[data-header="category_id"] [data-category-id]`);
                    const catId = catCell?.dataset.categoryId === 'null' ? null : catCell?.dataset.categoryId;
                    const subcatCell = this.dt_wrapper?.querySelector(`tr[data-id="${rowId}"] td[data-header="subcategory_id"] [data-subcategory-id]`);
                    const subcatId = subcatCell?.dataset.subcategoryId === 'null' ? null : subcatCell?.dataset.subcategoryId;
                    if (cellHeaderElement.dataset.editable === 'cat-dropdown') {
                        const currentCategoryValue = getCellValue(cell, 'category-id');
                        const categories = this.catSubRec;
                        renderDropdownEditor({
                            cell,
                            attr: 'category-id',
                            options: categories,
                            selectedValue: currentCategoryValue,
                            buttonContainer,
                            onSave: getSaveHandler(cell, 'category-id', categories, oldValue, onCellSaveAndCancel),
                            onCancel: getCancelHandler(oldValue, onCellSaveAndCancel)
                        });
                    }
                    if (cellHeaderElement.dataset.editable === 'subcat-dropdown') {
                        if (!catCell || !catId) {
                            window.toast.error('Please save a category first');
                            onCellSaveAndCancel(false, oldValue);
                            return;
                        }
                        const currentSubcategoryValue = getCellValue(cell, 'subcategory-id');
                        const subcategories = this.catSubRec.find(c => c.value.toString() === catId.toString())?.children || [];
                        renderDropdownEditor({
                            cell,
                            attr: 'subcategory-id',
                            options: subcategories,
                            selectedValue: currentSubcategoryValue,
                            buttonContainer,
                            onSave: getSaveHandler(cell, 'subcategory-id', subcategories, oldValue, onCellSaveAndCancel),
                            onCancel: getCancelHandler(oldValue, onCellSaveAndCancel)
                        });
                    }
                    if (cellHeaderElement.dataset.editable === 'rt-dropdown') {
                        if (!catCell || !subcatCell || !catId || !subcatId) {
                            window.toast.error('Please save a category and subcategory first');
                            onCellSaveAndCancel(false, oldValue);
                            return;
                        }
                        const currentRecordTypeValue = getCellValue(cell, 'record-type-id');
                        const recordTypes = this.catSubRec
                            .find(c => c.value.toString() === catId)
                            ?.children.find(c => c.value.toString() === subcatId)
                            ?.children || [];
                        renderDropdownEditor({
                            cell,
                            attr: 'record-type-id',
                            options: recordTypes,
                            selectedValue: currentRecordTypeValue,
                            buttonContainer,
                            onSave: getSaveHandler(cell, 'record-type-id', recordTypes, oldValue, onCellSaveAndCancel),
                            onCancel: getCancelHandler(oldValue, onCellSaveAndCancel)
                        });
                    }
                }
                if (cellHeaderElement.dataset.editable === 'period-dropdown') {
                    const currentPeriodValue = cell.querySelector('[data-period-id]').dataset.periodId || '';
                    renderDropdownEditor({
                        cell,
                        attr: 'period-id',
                        options: Object.entries(this.periods).map(([value, name]) => ({ value, name })),
                        selectedValue: currentPeriodValue,
                        buttonContainer,
                        onSave: (e) => {
                            const inputValue = cell.querySelector('select').value;
                            const template = `<div data-period-id="${inputValue}">${this.periods[inputValue]}</div>`;
                            onCellSaveAndCancel(true, oldValue, template);
                            e.stopPropagation();
                        },
                        onCancel: getCancelHandler(oldValue, onCellSaveAndCancel)
                    });
                }
                if (cellHeaderElement.dataset.editable === 'min-max-dropdown') {
                    const currentMinMaxValue = cell.textContent.trim();
                    renderDropdownEditor({
                        cell,
                        attr: 'min-max',
                        options: this.minMax.map(x => ({ value: x, name: x })),
                        selectedValue: currentMinMaxValue,
                        buttonContainer,
                        onSave: (e) => {
                            const inputValue = cell.querySelector('select').value;
                            onCellSaveAndCancel(true, oldValue, inputValue);
                            e.stopPropagation();
                        },
                        onCancel: getCancelHandler(oldValue, onCellSaveAndCancel)
                    });
                }
                if (cellHeaderElement.dataset.editable === 'link') {
                    const link = cell.querySelector('a');
                    const template = `<div class="flex gap-2 flex-col">
									<div contenteditable="true" no-empty class="editable-cell h-full w-full py-[9px] px-[6px] bg-white border-thin border-grey rounded-primary focus:outline-none">
										${escapeHTML(link.textContent)}
									</div>	
									${buttonContainer}
								</div>`;
                    cell.innerHTML = template;
                    cell.querySelector('.editable-cell').focus();
                    const save = (e) => {
                        const inputValue = cell.querySelector('.editable-cell').textContent.trim();
                        const escapedValue = escapeHTML(inputValue);
                        const isSafeLink = /^(https?:\/\/|mailto:)/i.test(inputValue);
                        const finalHref = isSafeLink ? escapedValue : "#";
                        const template = `<a href="${finalHref}" target="_blank" rel="noopener noreferrer">${escapedValue}</a>`;
                        onCellSaveAndCancel(true, oldValue, template);
                        e.stopPropagation();
                    };
                    const cancel = (e) => {
                        onCellSaveAndCancel(false, oldValue);
                        e.stopPropagation();
                    };
                    cell.querySelector('button.save').onclick = save;
                    cell.querySelector('button.cancel').onclick = cancel;
                    cell.querySelector('.editable-cell')?.addEventListener('paste', function (e) {
                        e.preventDefault();
                        const text = e.clipboardData?.getData('text/plain') || '';
                        const selection = window.getSelection();
                        if (!selection || !selection.rangeCount)
                            return;
                        selection.deleteFromDocument();
                        selection.getRangeAt(0).insertNode(document.createTextNode(text));
                    });
                }
            }
        });
    }
    _modify_cell(cellKey, newValue, fireChange = true, modifyInnerHTML = true, params = {}) {
        const rowId = this._get_row_id_from_cell_key(cellKey);
        const { col, cellHeader } = this._get_cell_header_from_cell_key(cellKey);
        if (!rowId || !cellHeader) {
            console.error('Invalid cell key:', cellKey);
            return;
        }
        const cell = this.dt.cell(`[data-cell-key="${cellKey}"]`).node() || this.getTable().querySelector(`[data-cell-key="${cellKey}"]`);
        if (cell) {
            cell.classList.add('modified');
            if (cell.dataset.editing === 'true') {
                cell.querySelector('button.cancel')?.click();
            }
            if (modifyInnerHTML)
                cell.innerHTML = newValue;
        }
        this.modified_cells.set(cellKey, newValue);
        if (this.selected_rows.has(Number(rowId))) {
            this.selected_rows.get(Number(rowId))[cellHeader] = newValue;
        }
        if (fireChange) {
            if (!cell?.dataset.isNew)
                return this.cell_save_callback({
                    value: newValue,
                    cell,
                    cellKey,
                    cellHeader,
                    col,
                    rowId,
                    dataTable: this,
                    params,
                });
            else {
                const row = this.dt.row(`[data-id="${rowId}"]`).node();
                const requiredCells = Array.from(row?.querySelectorAll(`td.required`) ?? []);
                const allRequiredFilled = requiredCells.every((c) => {
                    return c.classList.contains('modified');
                });
                if (allRequiredFilled) {
                    this.row_add_callback(row);
                }
            }
        }
    }
    _unmodify_cell(cellKey) {
        this.modified_cells.delete(cellKey);
        const cell = this.dt.cell(`[data-cell-key="${cellKey}"]`).node() || this.getTable().querySelector(`[data-cell-key="${cellKey}"]`);
        if (cell) {
            cell.classList.remove('modified');
        }
    }
    _insertTextInEditableCell(editable, text) {
        editable.focus();
        const sel = window.getSelection();
        if (!sel)
            return;
        const textNode = document.createTextNode(text);
        if (sel.rangeCount === 0) {
            editable.appendChild(textNode);
            return;
        }
        const range = sel.getRangeAt(0);
        if (!editable.contains(range.commonAncestorContainer)) {
            editable.appendChild(textNode);
            const after = document.createRange();
            after.setStartAfter(textNode);
            after.collapse(true);
            sel.removeAllRanges();
            sel.addRange(after);
            return;
        }
        range.deleteContents();
        range.insertNode(textNode);
        range.setStartAfter(textNode);
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
    }
    _replaceEditableCellText(editable, text) {
        editable.focus();
        editable.textContent = text;
        const range = document.createRange();
        range.selectNodeContents(editable);
        range.collapse(false);
        const sel = window.getSelection();
        if (sel) {
            sel.removeAllRanges();
            sel.addRange(range);
        }
    }
    _attachQcTextShortcuts() {
        const table = this.getTable();
        const WHO_SNIPPETS = ['Anyone', 'Taxpayers', 'Employers', 'Companies'];
        const FROM_SNIPPETS = [
            'From the date of',
            'From the date on which',
            'From the date following the Day',
        ];
        const digitSlotIndex = (code) => {
            const row = /^Digit([1-9])$/.exec(code);
            if (row)
                return Number(row[1]) - 1;
            const pad = /^Numpad([1-9])$/.exec(code);
            if (pad)
                return Number(pad[1]) - 1;
            return null;
        };
        const isShortcutChord = (e) => !e.altKey && (e.ctrlKey || e.metaKey) && e.shiftKey;
        const triggerShortcutCellSave = (cell) => {
            cell.querySelector('button.save')?.click();
        };
        const handler = (e) => {
            if (!isShortcutChord(e))
                return;
            const slot = digitSlotIndex(e.code);
            if (slot === null)
                return;
            const raw = e.target;
            const el = raw instanceof Element ? raw : raw.parentElement;
            if (!el || !table.contains(el))
                return;
            const cell = el.closest('td[data-header]');
            if (!cell || cell.dataset.editing !== 'true')
                return;
            const header = cell.dataset.header;
            const editable = el.closest('.editable-cell') ||
                cell.querySelector('.editable-cell');
            if (header === 'who') {
                const snippet = WHO_SNIPPETS[slot];
                if (!snippet || !editable?.isContentEditable)
                    return;
                e.preventDefault();
                e.stopPropagation();
                this._replaceEditableCellText(editable, snippet);
                triggerShortcutCellSave(cell);
                return;
            }
            if (header === 'retention') {
                const snippet = this.retentionValues[slot];
                if (snippet === undefined || snippet === '' || !editable?.isContentEditable)
                    return;
                e.preventDefault();
                e.stopPropagation();
                this._replaceEditableCellText(editable, snippet);
                triggerShortcutCellSave(cell);
                return;
            }
            if (header === 'from') {
                const snippet = FROM_SNIPPETS[slot];
                if (!snippet || !editable?.isContentEditable)
                    return;
                e.preventDefault();
                e.stopPropagation();
                this._replaceEditableCellText(editable, snippet);
                triggerShortcutCellSave(cell);
                return;
            }
            if (header === 'min_max') {
                const select = cell.querySelector('select');
                if (!select)
                    return;
                const options = this.minMax;
                if (!options?.length || slot < 0 || slot >= options.length)
                    return;
                const value = options[slot];
                const valueStr = String(value);
                const opt = [...select.options].find((o) => String(o.value) === valueStr);
                if (!opt)
                    return;
                e.preventDefault();
                e.stopPropagation();
                select.value = opt.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
                triggerShortcutCellSave(cell);
                return;
            }
            if (header === 'period') {
                const select = cell.querySelector('select');
                if (!select)
                    return;
                const periodEntries = Object.entries(this.periods);
                if (!periodEntries.length || slot < 0 || slot >= periodEntries.length)
                    return;
                const wantKey = String(periodEntries[slot][0]);
                const optionList = [...select.options];
                const opt = optionList.find((o) => String(o.value) === wantKey) ||
                    optionList.find((o) => o.value === wantKey) ||
                    optionList.filter((o) => o.value !== '' && !o.disabled)[slot];
                if (!opt)
                    return;
                e.preventDefault();
                e.stopPropagation();
                select.value = opt.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
                triggerShortcutCellSave(cell);
            }
        };
        table.addEventListener('keydown', handler, true);
    }
    _handle_timeline_action(sourceTimeline, targetTimeline, valueKey, fireChange = true) {
        if (sourceTimeline.length === 0)
            return;
        const lastAction = sourceTimeline.pop();
        if (!lastAction)
            return;
        const { action, cellKey } = lastAction;
        if (action === 'edit') {
            this._modify_cell(cellKey, lastAction[valueKey], fireChange);
            if (sourceTimeline === this.undo_timeline)
                if (!sourceTimeline.find(item => item.cellKey === cellKey)) {
                    this._unmodify_cell(cellKey);
                }
        }
        targetTimeline.push(lastAction);
    }
    constructor(tableSelector, options) {
        const customOptions = {
            colReorder: {
                allowReorder: false
            },
            columnDefs: [{
                    targets: -1,
                    orderable: false,
                }, {
                    targets: 0,
                    orderable: false,
                    render: () => '<input type="checkbox" class="row-select" />'
                }],
            rowPositionKey: 'excel_order',
            rowCallback: (row, rowData) => {
                const { id, excel_order } = rowData._meta;
                if (id)
                    row.dataset.id = Number(id);
                if (excel_order)
                    row.dataset.excel_order = Number(excel_order);
                this._row_callback(row);
            },
            ajax: {
                dataSrc: (json) => {
                    json.data = json.data.map(({ meta, data }) => {
                        if (meta.row_order) {
                            meta.excel_order = meta.row_order;
                        }
                        const array = data.map((cell) => {
                            return (0, index_1.replaceURLString)(cell);
                        });
                        array.unshift('select');
                        array._meta = meta;
                        return array;
                    });
                    return json.data;
                },
            },
            select: {
                style: 'single',
                items: 'cell',
                selector: 'td:not(:first-child):not([data-editing="true"])',
            },
            ...options,
        };
        super(tableSelector, customOptions);
        this._attachQcTextShortcuts();
        this.periods = options.periods || {};
        this.retentionValues = options.retentionValues || [];
        this.minMax = options.minMax || [];
        this.cell_save_callback = options.onCellSave || (() => { });
        this.cell_cancel_callback = options.onCellCancel || (() => { });
        this.row_add_callback = options.onRowAdd || (() => { });
        this.rowPositionKey = options.rowPositionKey || 'index';
        this.clientSide = options.clientSide || false;
        if (options.undoButton) {
            this.undo_button = document.querySelector(options.undoButton);
            this.undo_button?.addEventListener('click', () => this.undo());
            this._update_undo_button();
        }
        if (options.redoButton) {
            this.redo_button = document.querySelector(options.redoButton);
            this.redo_button?.addEventListener('click', () => this.redo());
            this._update_redo_button();
        }
        const table = this.getTable();
        const selectAllCheckbox = table.querySelector('.all');
        if (selectAllCheckbox) {
            selectAllCheckbox.addEventListener('change', (e) => {
                this.selectAllHandler(e.target.checked);
            });
        }
        this._initAsync(options);
    }
    async _initAsync(options) {
        const { data } = await axios_1.default.get(`${constants_1.API_URL}list/cat-sub-rec?multi-layer=true`, {
            headers: window.HEADER_OBJ
        });
        this.catSubRec = data;
        this.dt.on('draw', () => {
            this._check_select_all_rows_checkbox();
        });
    }
}
exports.default = QCDataTable;
